import template from './condition-type.jade';

export default angular
    .module('cian.addForm.aboutBuildingConditionType', ['cian.addForm.aboutObjectConditionType'])
    .directive('cianAfAboutBuildingConditionType', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller() {},
        controllerAs: 'conditionType',
        template,
    }))
    .name;
